/// <reference path="../../index.d.ts" />
//@ts-ignore
import * as counterpartypackage from '../../source/js/counterpartypackage-api';


export type FetchCounterpartyBriefListByFilterOptions =  {
	term?: string;
	selectLegalEntities?: boolean;
	selectTenantLegalEntities?: boolean;
	selectEmployees?: boolean;
	selectNaturalPersons?: boolean;
	counterpartyGroupIDList?: Array<TLong>;
};

const counterpartyApi = {
	package: counterpartypackage as typeof counterpartypackageApi,
	counterpartyService: {
		client: new counterpartypackage.CounterpartyServiceClient() as CounterpartyServiceClient,
		fetchCounterpartyBriefListByFilter: (options: FetchCounterpartyBriefListByFilterOptions) => {
			return new Promise<Array<CounterpartyBrief>>(resolve => {
				const CPFilter = new counterpartyApi.package.CounterpartyFilter();
				const { term = '', ...restOptions } = options;
				const mergedParams = {
					selectLegalEntities: false,
					selectTenantLegalEntities: false,
					selectEmployees: false,
					selectNaturalPerson: false,
					counterpartyGroupIDList: [],
					...restOptions
				};
		
				CPFilter.QueryString = term;
				CPFilter.SelectLegalEntities = mergedParams.selectLegalEntities;
				CPFilter.SelectTenantLegalEntities = mergedParams.selectTenantLegalEntities;
				CPFilter.SelectEmployees = mergedParams.selectEmployees;
				CPFilter.SelectNaturalPersons = mergedParams.selectNaturalPersons;
				CPFilter.CounterpartyGroupIDList = mergedParams.counterpartyGroupIDList;

				counterpartyApi.counterpartyService.client.getCounterpartyBriefListByFilter(CPFilter, result => {
					resolve(result);
				});
			});
		},
	},
};

export default counterpartyApi;
